import { useEffect, useState } from "react";
import { fetchFeaturedBlogPosts } from "../../api/GlobalApi";
import { Link } from "react-router-dom";

function FeaturedPosts() {

    const [blogPosts, setBlogPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchFeaturedBlogPosts()
        .then((data) => {
            setBlogPosts(Array.isArray(data) ? data : []);
            setLoading(false);
        })
        .catch(() => setLoading(false));
    }, []);

    function formatDate(dateString) {
        if (!dateString) return "N/A";
        return new Date(dateString).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric"
        });
    }

    function truncateText(text, maxLength) {
        if (!text) return "";
        return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
    }

    if (loading) return <p>Loading Latest Posts...</p>;

    return(
        <section className="section">
            <div className="section-header">
                <h2 className="section-title">Featured stories</h2>
                <Link to={'/blogs/featured'} href="#" className="see-more">See all</Link>
            </div>
            <div className="horizontal-scroll">
                {blogPosts.map((post) => (
                    <Link to={`/blog/${post.slug}`} key={post.id} className="game-card horizontal-card" style={{ textDecoration: "none" }}>
                        <div className="game-image" style={{
                            background: "linear-gradient(45deg, #f093fb, #f5576c)",
                            backgroundImage: `url(${post.featured_image_url})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                        }}>

                        <div className="game-icon"
                            style={{
                                backgroundImage: `url(${post.avatar_url})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                            }}
                        ></div>
                        </div>
                        <div className="game-info">
                            <div className="game-title">{truncateText(post.title, 40)}</div>
                            <div className="game-developer">
                                {post.category ?? "Uncategorized"} • {Math.ceil(post.content.split(" ").length / 200)} min read
                            </div>

                            <div className="game-rating">
                                <span className="rating-text">{formatDate(post.updated_at)}</span>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </section>
    );
}

export default FeaturedPosts;